import { EventEmitter } from "@angular/core";
import { ClareHomeDbCollection } from "@app/shared/resources/resource-objectifier";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { Action } from "@ngrx/store";
import * as DialogActions from "./dialog.action";
import * as RootStoreActions from "./root-store.actions";
import * as SnackbarActions from "./snackbar.action";

export * from "./router.action";
export { DialogActions, RootStoreActions, SnackbarActions };

export interface CHUuid {
    uuid: string;
}

export interface ActionPayloadGeneric {
    callbackEmitter?: EventEmitter<Action>;
    logData?: any;
}
export type DataError<T> = DataServiceError<T> & { uuid?: string };

export type CHDataActionPayload = Record<string, any> & CHUuid;

/**
 * @deprecated
 * Should opt to use the new action syntax
 */
export type SuccessActionResult<T> = {
    result: T;
} & ActionPayloadGeneric;
/**
 * @deprecated
 * Should opt to use the new action syntax
 */
export type CHSuccessActionResult<T> = SuccessActionResult<T> & CHUuid;
/**
 * @deprecated
 * Should opt to use the new action syntax
 */
export type CHSuccessActionCollectionResult<T> = SuccessActionResult<ClareHomeDbCollection<T>> & CHUuid;
